// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1mgOg","noInteraction":"EventWrapper_noInteraction__3tNgM"};